import { motion } from "framer-motion";
import { Plus } from "lucide-react";

const GROWTH_IMG =
  "https://images.pexels.com/photos/946310/pexels-photo-946310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export default function Growth() {
  return (
    <section
      id="growth"
      className="py-24 md:py-32 lg:py-48 max-w-[1800px] mx-auto px-8 md:px-16"
      data-testid="growth"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-6"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--mpg-gold)] mb-6">
            The Horizon
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8">
            We're <span className="italic font-light">growing.</span>
          </h2>
          <p className="text-base md:text-lg font-light leading-relaxed text-[var(--mpg-text-soft)] max-w-md mb-8">
            Madison Price Group is built to expand. We're always open to conversations with
            founders and operators of exceptional companies — and with those looking for a
            long-term home for a business they've built.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[var(--mpg-text)] group"
            data-testid="growth-cta"
          >
            <span className="link-underline">Start a conversation</span>
            <Plus size={16} className="group-hover:rotate-90 transition-transform duration-500" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-6 relative"
        >
          <div className="relative aspect-[4/3] overflow-hidden">
            <img src={GROWTH_IMG} alt="" className="w-full h-full object-cover grayscale opacity-70" />
            <div className="absolute inset-0 bg-[rgba(9,10,9,0.55)]" />
            {/* Dashed "next company" frame */}
            <div className="absolute inset-6 md:inset-10 border border-dashed border-[rgba(244,240,230,0.35)] flex items-center justify-center">
              <div className="text-center">
                <span className="font-mono text-sm tracking-[0.2em] text-[var(--mpg-gold)]">03</span>
                <p className="font-serif italic text-2xl md:text-3xl mt-2 text-[var(--mpg-text)]">
                  The next chapter
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
